import { ERouteHttpVerb } from "@devowl-wp/api";
const routeLocationSupportSubscriptionCancelationPost = {
    path: "/support/subscription-cancelation",
    method: ERouteHttpVerb.POST
};
export { routeLocationSupportSubscriptionCancelationPost };
